module.exports = __webpack_public_path__ + "static/office-mobile-85b8e1338674bc6dd0202e4dc84a48e4.jpg";